// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"24":"leaguevideos","37":"draftroom","141":"history","185":"season2021","466":"constitution","552":"rules","770":"leaguelosers"}[chunkId] + "." + {"24":"6adf990c","37":"b3e57123","141":"f038c900","185":"23ad43ce","466":"cd173797","552":"9b2f8594","770":"d5635995"}[chunkId] + ".css";
};